(() => {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-description-open]');
    if (!button) return;

    const details = document.querySelector('details[id^="Description-"]');
    if (!details) return;

    if (!details.open) {
      details.querySelector('summary')?.click();
    }

    details.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();